import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PatientAppointmentHistoryFilter from "./patientAppointmentHistoryFilter";
import PatientAppointmentHistoryGrid from "./patientAppointmentHistoryGrid";

import '../css/patientHistory.css';
import { useActiveTab } from "./activeTabContext";

export interface AppointmentHistoryFilters {
    hideMHD: boolean,
    hidePSA: boolean,
    includeCanceled: boolean,
}

const PatientAppointmentHistory = (
    {
        showLoseProgressWarning,
        enableShowPSAandMHDfilters,
    }: {
        showLoseProgressWarning: boolean,
        enableShowPSAandMHDfilters: boolean,
    }
) => {
    const appointmentHistoryRecords = useSelector((state: any) => state.activePatient.history);
    const [filters, setFilters] = useState<AppointmentHistoryFilters>(
        {
            hideMHD: false,
            hidePSA: false,
            includeCanceled: false
        }
    )

    const { activeTab } = useActiveTab();

    useEffect(() => {
        if (activeTab?.reloadTabContent) {
            setFilters({
                hideMHD: false,
                hidePSA: false,
                includeCanceled: false
            });
        }
    }, [activeTab]);

    //TODO better name
    const showPSAandMHDfilters = enableShowPSAandMHDfilters
        && appointmentHistoryRecords?.some((x: any) => x.scheduleMethod === "PSA")
        && appointmentHistoryRecords?.some((x: any) => x.scheduleMethod === "MHD");

    return (
        <div>
            <div>
                {appointmentHistoryRecords?.length > 0 &&
                    <div className="col" style={{ padding: '0px' }}>
                        <PatientAppointmentHistoryFilter
                            filters={filters}
                            setFilters={setFilters}
                            showPSAandMHDfilters={showPSAandMHDfilters}
                        />
                        <PatientAppointmentHistoryGrid
                            appointmentHistoryRecords={appointmentHistoryRecords}
                            filters={filters}
                            showLoseProgressWarning={showLoseProgressWarning}
                        />
                    </div>
                }
                {appointmentHistoryRecords && (appointmentHistoryRecords.length === 0) &&
                    <PatientHistoryEmptyList />
                }
            </div>
        </div>
    )
}

function PatientHistoryEmptyList() {
    return (
        <div>
            <h5 className="history-result-header">No history records found.</h5>
        </div>
    );
}

export default PatientAppointmentHistory;